// "Warum das gut tut" nach Canvas R3-T1-Start: Titel mit Blatt, Einleitung (leise), Stichpunkte mit
// Punkt in Tuerkis und fetter Zutat. Gilt fuer Start und Rezeptseite.
import type { ReactNode } from 'react';
import { warumZerlegen } from '../lib/rezept';
import { Icon } from './Icon';
import s from './warum.module.css';

export function WarumGutKarte({ id, text, abstand = 'abschnitt', fuss }: { id: string; text: string; abstand?: 'abschnitt' | 'start'; fuss?: ReactNode }) {
  const w = warumZerlegen(text);
  return (
    <section aria-labelledby={id} className={`${s.karte} ${abstand === 'start' ? s.start : s.abschnitt}`}>
      <h2 id={id} className={s.titel}>
        <span aria-hidden="true" className={s.icon}>
          <Icon name="blatt" groesse={18} strich={1.9} />
        </span>
        Warum das gut tut
      </h2>
      {w.einleitung && <p className={w.punkte.length > 0 ? s.einleitung : s.fliesstext}>{w.einleitung}</p>}
      {w.punkte.length > 0 && (
        <ul className={s.liste}>
          {w.punkte.map((p, i) => (
            <li key={i}>
              <span aria-hidden="true" className={s.punkt} />
              <p>
                {p.zutat && <strong>{p.zutat}:</strong>} {p.text}
              </p>
            </li>
          ))}
        </ul>
      )}
      {fuss}
    </section>
  );
}
